"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStyleOptions;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStyleOptions() {
  return [(0, _useWebChatAPIContext.default)().styleOptions];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTdHlsZU9wdGlvbnMiLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsInN0eWxlT3B0aW9ucyJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVN0eWxlT3B0aW9ucy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdHJpY3RTdHlsZU9wdGlvbnMgfSBmcm9tICcuLi9TdHlsZU9wdGlvbnMnO1xuaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTdHlsZU9wdGlvbnMoKTogW1N0cmljdFN0eWxlT3B0aW9uc10ge1xuICByZXR1cm4gW3VzZVdlYkNoYXRBUElDb250ZXh0KCkuc3R5bGVPcHRpb25zXTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOzs7O0FBRWUsU0FBU0EsZUFBVCxHQUFpRDtFQUM5RCxPQUFPLENBQUMsSUFBQUMsNkJBQUEsSUFBdUJDLFlBQXhCLENBQVA7QUFDRCJ9